export const MODULE_URL = 'https://static.parastorage.com/unpkg'
